module.exports = __webpack_public_path__ + "images/gray_bg-c973dc4b4b.png";